import dayjs from "dayjs";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export const setRecentlyViewedExpiry = (): dayjs.Dayjs =>
  dayjs().add(14, "day");

export const notRecentlyViewedExpired = (expiry: dayjs.Dayjs) =>
  dayjs().isBefore(expiry);

export type DiscoveryV2RecentlyViewedStoreState = {
  recentlyViewed: {
    id: number;
    supplierId: number;
    name: string;
    imageUrl?: string | null;
    logoUrl?: string | null;
    urlId: string;
    details: string;
    expiry: dayjs.Dayjs;
    containsPreOrderProductItem: boolean;
  }[];
};

type DiscoveryV2RecentlyViewedStoreActions = {
  add: (
    product: DiscoveryV2RecentlyViewedStoreState["recentlyViewed"][number],
  ) => void;
  reset: () => void;
};

const initialDiscoveryV2RecentlyViewedStoreState: DiscoveryV2RecentlyViewedStoreState =
  {
    recentlyViewed: [],
  };

const notAlreadyViewed = ({
  view,
  previous,
}: {
  view: DiscoveryV2RecentlyViewedStoreState["recentlyViewed"][number];
  previous: DiscoveryV2RecentlyViewedStoreState["recentlyViewed"];
}) => {
  return previous.filter((prev) => prev.id === view.id).length === 0;
};

export const useDiscoveryV2RecentlyViewedStore = create<
  DiscoveryV2RecentlyViewedStoreState & DiscoveryV2RecentlyViewedStoreActions
>()(
  persist(
    (set) => ({
      ...initialDiscoveryV2RecentlyViewedStoreState,
      add: (product) =>
        set(({ recentlyViewed: prev }) => {
          if (notAlreadyViewed({ view: product, previous: prev }))
            return {
              recentlyViewed: [product, ...prev].slice(0, 6),
            };
          return {
            recentlyViewed: prev,
          };
        }),
      reset: () => set(initialDiscoveryV2RecentlyViewedStoreState),
    }),
    {
      name: "discoveryRecentlyViewed",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        recentlyViewed: state.recentlyViewed,
      }),
    },
  ),
);
